import React from "react";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";

// İlan oluştururken işlem türü seçimi: Satılık (sale) / Kiralık (rent).
// Redux: newAdvert.listingType — backend Advert.listingType ile eşleşir.
const OPTIONS = [
  { value: "sale", label: "Satılık", color: "#1EC28B" },
  { value: "rent", label: "Kiralık", color: "#2D8CF0" },
];

function ListingTypeSelect(props) {
  const { listingType } = useSelector((state) => ({
    listingType: state.advert.newAdvert.listingType,
  }));

  const active = listingType || "sale";

  return (
    <div className="listing-type-select">
      <span className="listing-type-select__label">İlan Türü</span>
      <div className="listing-type-select__options">
        {OPTIONS.map((opt) => {
          const isActive = active === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => props.editNewAdvert("listingType", opt.value)}
              className="listing-type-select__option"
              style={{
                background: isActive ? opt.color : "#fff",
                color: isActive ? "#fff" : opt.color,
                borderColor: opt.color,
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default connect(null, { ...advertRedux.actions })(ListingTypeSelect);
